import React from 'react';
import { Card, Form, Input, Button, Switch, Select, message, Divider } from 'antd';

const { Option } = Select;

const Settings = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    message.success('设置已保存');
  };

  const initialValues = {
    siteName: '大鱼同步课堂',
    siteDescription: '在线教育平台',
    allowRegistration: true,
    emailNotifications: true,
    maxStudentsPerCourse: 50,
    sessionTimeout: 30,
    defaultLanguage: 'zh-CN',
    theme: 'light',
  };

  return (
    <div>
      <Card title="系统设置">
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          onFinish={handleSubmit}
        >
          <Divider orientation="left">基本设置</Divider>
          
          <Form.Item
            name="siteName"
            label="站点名称"
            rules={[{ required: true, message: '请输入站点名称' }]}
          >
            <Input placeholder="请输入站点名称" />
          </Form.Item>
          
          <Form.Item
            name="siteDescription"
            label="站点描述"
          >
            <Input.TextArea rows={3} placeholder="请输入站点描述" />
          </Form.Item>
          
          <Form.Item
            name="defaultLanguage"
            label="默认语言"
          >
            <Select>
              <Option value="zh-CN">中文简体</Option>
              <Option value="zh-TW">中文繁体</Option>
              <Option value="en-US">English</Option>
            </Select>
          </Form.Item>
          
          <Form.Item
            name="theme"
            label="主题"
          >
            <Select>
              <Option value="light">浅色主题</Option>
              <Option value="dark">深色主题</Option>
            </Select>
          </Form.Item>

          <Divider orientation="left">用户设置</Divider>
          
          <Form.Item
            name="allowRegistration"
            label="允许用户注册"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          
          <Form.Item
            name="emailNotifications"
            label="邮件通知"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          
          <Form.Item
            name="sessionTimeout"
            label="会话超时时间(分钟)"
          >
            <Input type="number" placeholder="请输入会话超时时间" />
          </Form.Item>

          <Divider orientation="left">课程设置</Divider>
          
          <Form.Item
            name="maxStudentsPerCourse"
            label="每个课程最大学生数"
          >
            <Input type="number" placeholder="请输入最大学生数" />
          </Form.Item>
          
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large">
              保存设置
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Settings;
